import {MainException} from 'common/exception/MainException';
import {ExceptionContract} from 'common/exception/ExceptionContract';

export class NotImplementedException extends MainException implements ExceptionContract {
    public constructor(message: string, data?: {[key: string]: any}) {
        super(message, 501, data);
        this.name = 'NotImplementedException';
    }
}
